import { AxiosClient } from "./AxiosClient";

export const getSources = () => {
  try {
    return AxiosClient.get("feed/getSources", { useTarget: true });
  } catch (e) {
    console.log(e);
  }
};

export const getFeed = (payload) => {
  try {
    return AxiosClient.post("feed/getFeed", payload, { useTarget: true });
  } catch (e) {
    console.log(e);
  }
};

export const getProductFeed = (payload) => {
  try {
    return AxiosClient.post("feed/getProductFeed", payload, {
      useTarget: true,
    });
  } catch (e) {
    console.log(e);
  }
};

export const getProductFlagsOrClassifications = (flagclass) => {
  try {
    return AxiosClient.get("feed/getProductFlagsOrClassifications", {
      params: { flagclass },
    });
  } catch (e) {
    console.log(e);
  }
};

export const toggleThumb = (payload) => {
  try {
    return AxiosClient.post("feed/toggleThumb", payload);
  } catch (e) {
    console.log(e);
  }
};

export const toggleProductConfidence = (payload) => {
  try {
    return AxiosClient.post("feed/toggleProductConfidence", payload);
  } catch (e) {
    console.log(e);
  }
};

export const getStats = (payload) => {
  try {
    return AxiosClient.post("feed/getStats", payload, { useTarget: true });
  } catch (e) {
    console.log(e);
  }
};

export const getRecentWindow = (offset, domains, filters) => {
  try {
    return AxiosClient.get(
      "feed/getRecentWindow?offset=" +
        offset +
        "&domains=" +
        domains +
        "&filters=" +
        filters,
    );
  } catch (e) {
    console.log(e);
  }
};

export const getRecDocs = (offset) => {
  try {
    return AxiosClient.get("feed/getRecDocs?offset=" + offset);
  } catch (e) {
    console.log(e);
  }
};

export const getSavedItems = (offset) => {
  try {
    return AxiosClient.get("saved/getSavedItems?offset=" + offset);
  } catch (e) {
    console.log(e);
  }
};

export const getAllSavedItemsExcel = () => {
  try {
    return AxiosClient.get("saved/getAllSavedItemsExcel");
  } catch (e) {
    console.log(e);
  }
};

export const updateLike = (thumb, type, data) => {
  try {
    return AxiosClient.post("chat/updateLike", { thumb, type, data });
  } catch (e) {
    console.log(e);
  }
};

export const updateDislike = (thumb, type, data) => {
  try {
    return AxiosClient.post("chat/updateDislike", { thumb, type, data });
  } catch (e) {
    console.log(e);
  }
};

export const updateCatalog = (type, data) => {
  try {
    return AxiosClient.post("chat/updateCatalog", { type, data });
  } catch (e) {
    console.log(e);
  }
};

/* ─── Feed Views & Favorites ─── */

export const getFeedViews = () => {
  try {
    return AxiosClient.get("feed/getFeedViews");
  } catch (e) {
    console.log(e);
  }
};

export const createFeedView = (payload) => {
  try {
    return AxiosClient.post("feed/createFeedView", payload);
  } catch (e) {
    console.log(e);
  }
};

export const updateFeedView = (payload) => {
  try {
    return AxiosClient.post("feed/updateFeedView", payload);
  } catch (e) {
    console.log(e);
  }
};

export const deleteFeedView = (payload) => {
  try {
    return AxiosClient.post("feed/deleteFeedView", payload);
  } catch (e) {
    console.log(e);
  }
};

export const favoriteFeedSource = (payload) => {
  try {
    return AxiosClient.post("feed/favoriteFeedSource", payload);
  } catch (e) {
    console.log(e);
  }
};

export const unfavoriteFeedSource = (payload) => {
  try {
    return AxiosClient.post("feed/unfavoriteFeedSource", payload);
  } catch (e) {
    console.log(e);
  }
};

export const getFeedViewStats = (payload) => {
  try {
    return AxiosClient.post("feed/getFeedViewStats", payload);
  } catch (e) {
    console.log(e);
  }
};

export const saveFeedViewOrder = (payload) => {
  try {
    return AxiosClient.post("feed/saveFeedViewOrder", payload);
  } catch (e) {
    console.log(e);
  }
};

export const exportCatalog = () => {
  try {
    return AxiosClient.get("feed/exportCatalog");
  } catch (e) {
    console.log(e);
  }
};
